export const FEATURE_APPLICATION = "application";

/**
 * Represents the domain name used by the application.
 *
 * This variable contains the full domain URL where the application is hosted.
 * It is used for network requests, configuration settings, or referencing
 * the application's main domain across the code.
 *
 * Value example: "events.jugru.org"
 */
export const APP_NAME_DOMAIN = "events.jugru.org";

/**
 * Represents the prefix for locale-related cookies used in the application.
 * It is typically used to identify and manage cookie keys associated with user locale settings.
 */
export const APP_COOKIE_PREFIX = APP_NAME_DOMAIN;
export const APP_LS_PREFIX = APP_NAME_DOMAIN;

/**
 * Configuration object for application cookie settings.
 *
 * @type {Object}
 * @property {number} expires - Specifies the cookie's expiration duration in the past days. Default is 365 days (1 year).
 * @property {string} sameSite - Specifies the SameSite attribute for cookies to control cross-site request behavior. Default is "strict".
 */
export const APP_COOKIE_OPTIONS: object = {
  //TODO check if need
  expires: 365, // 1 year
  sameSite: "strict",
};

/**
 * Represents the key for the locale cookie used in the application.
 * This key is used to store and retrieve the user's locale preference from cookies.
 */
export const LOCALE_COOKIE_KEY = `${APP_COOKIE_PREFIX}.locale`;

/**
 * A constant representing the key used to store the state of the sidebar
 * in browser cookies. This key is constructed using the application-wide
 * cookie prefix and the identifier for sidebar state.
 *
 * The value associated with this key can typically determine if the sidebar
 * is collapsed, expanded, or any other predefined state.
 *
 * It ensures a consistent naming convention for cookie management
 * across the application.
 */
export const SIDEBAR_COOKIE_KEY = `${APP_COOKIE_PREFIX}.sidebar_state`;
